var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207 101.61L40.7 5.52C18.33-7.41 0 3.16 0 29v143.47l54.85-31.59V77.01l82.55 47.89-102.13 59.64C12.93 197.51.22 220.23.21 246.07V300l54.24-31.33v-32L207 148.6c22.37-12.92 22.38-34.06 0-46.99z"
  })));
}
export default SvgLogoSm;